import React from 'react';
import { createRoot } from 'react-dom/client';

import { isSigningRoute, signingRouteNeedsReload } from './signing/protocol';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

// Do not initialize dashboard auth, Supabase, analytics or project data for a
// customer capability link. Both branches load only after route classification.
const publicSigning = isSigningRoute(window.location.hash);
const initialHash = window.location.hash;
window.addEventListener('hashchange', () => {
  if (signingRouteNeedsReload(initialHash, window.location.hash)) {
    window.location.reload();
  }
});
if (publicSigning) {
  for (const [name, content] of [['referrer', 'no-referrer'], ['robots', 'noindex, nofollow, noarchive'], ['viewport', 'width=device-width, initial-scale=1']]) {
    const meta = document.createElement('meta'); meta.name = name; meta.content = content; document.head.appendChild(meta);
  }
  if (window.self !== window.top) root.render(<p>Open the original proposal link directly in your browser to review it.</p>);
  else import('./signing/SigningPage').then(({ default: SigningPage }) => root.render(<SigningPage />))
    .catch(() => root.render(<p>The proposal page could not load. Reopen the original link or contact T&amp;T.</p>));
} else {
  import('./AppWithAuth').then(({ default: AppWithAuth }) => root.render(<AppWithAuth />))
    .catch(() => root.render(<p>The app could not load. Please refresh the page.</p>));
}
